/* disable-eslint */
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title, CategoryScale, LinearScale, BarElement } from "chart.js";
import { Pie, Bar } from 'react-chartjs-2';
import { faker } from '@faker-js/faker';
import { useEffect, useRef, useState } from "react";
import { Field, Form, Formik } from "formik";
import classNames from "classnames";
import moment from "moment";
import BeatLoader from "react-spinners/BeatLoader";
import { useSelector } from "react-redux";
import Select from "../components/Select";
import { useNavigate } from "react-router-dom";
import { handleLogout } from '../config/axios';
import { fetchUserInfo, prepareAgentCodes } from "../services/userService";

ChartJS.register(ArcElement, Tooltip, Legend, Title, CategoryScale, LinearScale, BarElement);
export default function Dashboard() {
  const [_data, setData]: [any, any] = useState({});
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState('');
  const navigate = useNavigate();
  const [agentFilters, setAgentFilters] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(() => {
    const savedFilters = sessionStorage.getItem('dashboard-filters');
    if (savedFilters) {
      const parsedFilters = JSON.parse(savedFilters);
      return parsedFilters.selectedAgent || null;
    }
    return null;
  });

  const [theme, setTheme] = useState('light');
  const colorsLight = [
    '#6EA8FE', '#FF9E85', '#FFC97F', '#7FFFA1', '#B597FF',
    '#FFE77A', '#FFA8C5', '#89CFF0', '#C97AB5', '#FF9B74'
  ];

  const colorsDark = [
    '#4E6896', '#B35F5A', '#C08E4A', '#5F946A', '#816AB2',
    '#A2965C', '#B86E83', '#6589A8', '#A15985', '#B86152'
  ];

  const currentTheme = useSelector((state: any) => state.menu.theme);

  useEffect(() => {
    setTheme(currentTheme);
  }, [currentTheme]);

  const colors = theme === 'dark' ? colorsDark : colorsLight;



  const fetchData = async (filters: any = {}) => {
    setLoading(true);

    try {
      const data: any = {};

      // Ottieni informazioni aggiornate su agente da Keycloak se necessario
      let agentCodesToUse = [];
      
      if (filters.codice_agente) {
        // Se c'è un codice agente specifico selezionato, usa quello
        agentCodesToUse = [filters.codice_agente];
      } else {
        // Altrimenti, ottieni i codici agente dall'utente corrente
        const { isSupervisor, agentCodes } = await fetchUserInfo();
        
        // Per supervisor senza selezione, non inviamo codice agente (verranno usati tutti)
        // Per agenti normali, inviamo tutti i codici agente disponibili
        if (!isSupervisor && agentCodes.length > 0) {
          // Qui gestiamo il caso dell'agente con più codici
          agentCodesToUse = agentCodes;
        }
      }
      
      // Gestione dei filtri
      if (filters) {
        const { from, to } = filters;
        if (from) data.from = from;
        if (to) data.to = to;
        // Gestiamo il codice agente solo se abbiamo un valore da utilizzare
        if (agentCodesToUse.length === 1) {
          data.codice_agente = agentCodesToUse[0];
        } else if (agentCodesToUse.length > 1) {
          // Se abbiamo più codici, li inviamo come agenti (array)
          data.agenti = agentCodesToUse;
        }
      }

      // Costruzione query string
      const queryParams = new URLSearchParams();
      if (data.from) queryParams.append('from', data.from);
      if (data.to) queryParams.append('to', data.to);
      if (data.codice_agente) {
        queryParams.append('codice_agente', data.codice_agente);
      } else if (data.agenti && data.agenti.length > 0) {
        // Se abbiamo un array di codici agente, lo passiamo come JSON
        queryParams.append('agenti', JSON.stringify(data.agenti));
      }

      const request = await fetch(`/api/v1/dashboard/list?${queryParams.toString()}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (request.status === 401 || request.status === 403) {
        handleLogout();
        return;
      }

      if (request.status === 500) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        handleLogout();
        return;
      }

      const response = await request.json();

      setData(response.data);

      // Se riceviamo informazioni sul ruolo e gli agenti, le salviamo
      if (response.data.role) setUserRole(response.data.role);
      if (response.data.agents) setAgentFilters(response.data.agents);

    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  // Modifica l'useEffect iniziale
  useEffect(() => {
    const initializeData = async () => {
      const savedFilters = sessionStorage.getItem('dashboard-filters');
      let initialFilters = {
        from: moment().subtract(1, 'month').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD')
      };

      if (savedFilters) {
        const parsedFilters = JSON.parse(savedFilters);
        initialFilters = {
          ...initialFilters,
          ...parsedFilters,
          codice_agente: parsedFilters.selectedAgent?.value
        };
      }

      await fetchData(initialFilters);
    };

    initializeData();
  }, []);

  const formikRef: any = useRef();
/*   function formatThousands(num) {
    if (!num) return '0';

    if (Math.abs(num) >= 1000) {
      const formatted = (num / 1000).toLocaleString('it-IT', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
      });

      // Aggiungi il suffisso k
      return `${formatted}k`;
    }

    return num.toLocaleString('it-IT');
  } */

    function formatThousands(num) {
      if (num === null || num === undefined) return '0';
    
      return Math.abs(num).toLocaleString('it-IT');
    }
    

  return (
    <Formik
      innerRef={formikRef}
      enableReinitialize={true}
      initialValues={{
        from: sessionStorage.getItem('dashboard-filters') ?
          JSON.parse(sessionStorage.getItem('dashboard-filters')).from :
          moment().subtract(1, 'month').format('YYYY-MM-DD'),
        to: sessionStorage.getItem('dashboard-filters') ?
          JSON.parse(sessionStorage.getItem('dashboard-filters')).to :
          moment().format('YYYY-MM-DD'),
        codice_agente: sessionStorage.getItem('dashboard-filters') ?
          JSON.parse(sessionStorage.getItem('dashboard-filters')).codice_agente :
          ''
      }}
      validateOnChange={false}
      onSubmit={async (values) => {
        // Salva i filtri nel sessionStorage
        const filtersToSave = {
          ...values,
          selectedAgent
        };
        sessionStorage.setItem('dashboard-filters', JSON.stringify(filtersToSave));
        await fetchData(values);
      }}
    >
      {({ isSubmitting, values, resetForm, errors, touched, setFieldValue }) => (
        <Form>
          <div className="py-8 pb-24 columns-3xl lg:columns-auto">
            {/* Mostra uno spinner o un segnale di caricamento se loading è true */}
            {loading ? (
              <div className="flex justify-center items-center h-screen">
                <BeatLoader color="#2563eb" />
              </div>
            ) : (
              <div>
             
                {/* -------------- */}
                <div className='grid grid-cols-1 sm:grid-cols-5 mt-24 sm:items-start'>
                  <div className='px-6 hidden sm:block sm:sticky sm:top-32'>
                    <div className='flex justify-between items-center'>
                      <div className='flex gap-5'>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='flex flex-col md:flex-row items-center justify-center items-start gap-5 gap-y-10 md:gap-y-0'>
                  <h5 className="md:hidden text-4xl text-blue-500 sm:max-w-72 font-bold sm:mb-24 w-[100%] text-center">Seleziona periodo</h5>
                  {userRole === 'supervisor' && agentFilters.length > 0 && (

                    
                    <Select
                      options={agentFilters.map(agent => ({
                        value: agent.db2_user_id,
                        label: `${agent.first_name} ${agent.last_name}`
                      }))}
                      placeholder="Seleziona Agente"
                      value={selectedAgent}
                      onChange={val => {
                        setSelectedAgent(val);
                        setFieldValue('codice_agente', val?.value || '');
                      }}
                      classNames={{
                        container: state => `md:w-auto`,
                        control: state => `cu-dash-agent cu-wi-se min-h-c border border-neutral-300 dark:border-neutral-400`,
                        singleValue: state => `!text-neutral-500 dark:!text-neutral-400`,
                        option: state => `hover:bg-blue-500 hover:text-white`
                      }}
                    />

                  )}


                  <div className="date-input-container cu-dash-datepicker">
                    <Field
                      type="date"
                      name="from"  // cambiato da "date" a "from"
                      value={values.from}
                      onChange={(e: any) => {
                        setFieldValue('from', e?.target.value)
                      }}
                      className={classNames({
                        "min-h-c placeholder-current::placeholder px-2 block text-neutral-600 dark:text-neutral-400  border bg-transparent  focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none rounded": true,
                        "border-red-600": errors.from,  // cambiato da errors.date a errors.from
                        "border-neutral-300": !errors.from  // cambiato da !errors.date a !errors.from
                      })}
                      placeholder="Da"
                      style={{
                        colorScheme: theme === 'dark' ? 'dark' : 'light',
                      }}
                    />
                  </div>
                  {errors.from && touched.from ? (  // cambiato da date a from
                    <div className='text-red-600 my-2'>
                      <p>{typeof (errors?.from) === "string" ? errors?.from : ""}</p>
                      <p>{Array.isArray(errors?.from) ? errors?.from.join(", ") : ""}</p>
                    </div>
                  ) : null}
                  <div className="date-input-container cu-dash-datepicker">
                    <Field
                      type="date"
                      name="to"  // cambiato da "date" a "to"
                      value={values.to}
                      onChange={(e: any) => setFieldValue('to', e?.target.value)}
                      className={classNames({
                        "min-h-c placeholder-current::placeholder min-h-c px-2 block text-neutral-600 dark:text-neutral-400  border bg-transparent  focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none rounded": true,
                        "border-red-600": errors.to,  // cambiato da errors.date a errors.to
                        "border-neutral-300": !errors.to  // cambiato da !errors.date a !errors.to
                      })}
                      placeholder="A"
                      style={{
                        colorScheme: theme === 'dark' ? 'dark' : 'light',
                      }}
                    />
                  </div>
                  {errors.to && touched.to ? (  // cambiato da date a to
                    <div className='text-red-600 my-2'>
                      <p>{typeof (errors?.to) === "string" ? errors?.to : ""}</p>
                      <p>{Array.isArray(errors?.to) ? errors?.to.join(", ") : ""}</p>
                    </div>
                  ) : null}
                  <div className=''>
                    <button type="submit" className="min-h-c py-2 px-5 bg-blue-600 text-white font-semibold  hover:bg-blue-700">Cerca</button>
                  </div>




                </div>
                <div className="block md:hidden mt-[60px]"></div>
                <hr className="md:hidden" />
                <div className='md:mt-12 py-[60px] border-b-2 flex flex-col md:flex md:flex-row items-center justify-center gap-[5rem]'>
                  <div className="text-center">
                    <h2 className="text-3xl text-blue-600">{formatThousands(_data.lastDashboardTicket ? Number(_data?.lastDashboardTicket[0]?.valore_merce_assegnata) : 0)}</h2>
                    <p className="text-xl">Valore merce assegnata</p>
                  </div>
                  <div className="w-[1px] h-[150px] bg-slate-500 hidden md:block"></div>
                  <div className="text-center">
                    <h2 className="text-3xl text-blue-600">{_data?.queryOrdini ? formatThousands(_data?.queryOrdini[0].count) : 0}</h2>
                    <p className="text-xl">Numero ordini</p>
                  </div>
                  <div className="w-[1px] h-[150px] bg-slate-500 hidden md:block"></div>
                  <div className="text-center">
                    <h2 className="text-3xl text-blue-600">{_data?.queryClienti ?
                      formatThousands(_data.queryClienti.filter(x => x.stato_cliente === 'Bloccato').map(x => Number(x.count)).reduce((accumulator, currentValue) => accumulator + currentValue, 0))
                      : 0}</h2>
                    <p className="text-xl">Clienti bloccati</p>
                  </div>
                  <div className="w-[1px] h-[150px] bg-slate-500 hidden md:block"></div>
                  <div className="text-center">
                    <h2 className="text-3xl text-blue-600">{_data?.queryClienti ?
                      formatThousands(_data.queryClienti.filter(x => x.stato_cliente === 'Cliente attivo').map(x => Number(x.count)).reduce((accumulator, currentValue) => accumulator + currentValue, 0))
                      : 0}</h2>
                    <p className="text-xl">Clienti attivi</p>
                  </div>
                </div>
                <div className="mt-cu-m flex flex-col md:flex-row justify-between-c items-center max-h-[500px] ml-[16%] mr-[16%]">
                  <div className="text-center">
                    <div className="h-[250px] md:h-[500px] w-full md:w-[450px] block">
                      <Pie
                        options={{
                          plugins: {
                            legend: {
                              labels: {
                                color: theme === 'dark' ? '#c3c3c3' : '#000000', // Cambia il colore del testo della legenda in base al tema
                              },
                            },
                            title: {
                              display: true,
                              text: 'Ordini per cliente',
                              color: theme === 'dark' ? '#c3c3c3' : '#000000', // Cambia il colore del testo del titolo
                            },
                          },
                        }}
                        data={{
                          labels: _data.querySommaOrdini ? _data.querySommaOrdini.map(x => x.ragione_sociale) : [],
                          datasets: [
                            {
                              label: 'Ordini per cliente',
                              title: "Ordini per cliente",
                              fill: true,
                              backgroundColor: colors, // Usa i colori definiti
                              data: _data.querySommaOrdini ? _data.querySommaOrdini.map(x => x.conteggio) : [],
                              // Notice the borderColor 
                              borderColor: colors,
                              borderWidth: [2, 2]
                            }
                          ]
                        } as any}
                      />
                    </div>

                  </div>
                  <div className="block md:hidden w-full h-[1px] bg-[#000] mb-[65px]">

                  </div>
                  <div className="text-center">
                    <div className="h-[500px] w-full md:w-[500px] hidden md:block">
                      <Bar
                        data={{
                          labels: _data.querySommaOrdini ? _data.querySommaOrdini.map(x => x.ragione_sociale) : [],
                          datasets: [
                            {
                              label: 'Ordini per cliente',
                              data: _data.querySommaOrdini ? _data.querySommaOrdini.map(x => x.conteggio) : [],
                              backgroundColor: colors,
                            },
                          ],
                        }}
                        options={
                          {
                            maintainAspectRatio: false,
                            indexAxis: 'y' as const,
                            elements: {
                              bar: {
                                borderWidth: 2,
                              },
                            },
                            responsive: true,
                            plugins: {
                              legend: {
                                position: 'top' as const,
                                labels: {
                                  color: theme === 'dark' ? '#c3c3c3' : '#000000', // Cambia il colore del testo della legenda
                                },
                              },
                              title: {
                                display: true,
                                text: 'Ordini per cliente',
                                color: theme === 'dark' ? '#c3c3c3' : '#000000', // Cambia il colore del testo del titolo
                              },
                            },
                            scales: {
                              x: {
                                ticks: {
                                  color: theme === 'dark' ? '#c3c3c3' : '#000000', // Colore del testo sull'asse X
                                },
                              },
                              y: {
                                ticks: {
                                  color: theme === 'dark' ? '#c3c3c3' : '#000000', // Colore del testo sull'asse Y (etichette come i nomi delle aziende)
                                },
                              },
                            },
                          }
                        } />
                    </div>

                    <div className="h-[300px] w-full md:w-[500px] md:hidden">
                      <Bar
                        data={{
                          labels: _data.querySommaOrdini ? _data.querySommaOrdini.map(x => x.ragione_sociale.replace('unipersonale', '')) : [],
                          datasets: [
                            {
                              label: 'Ordini per cliente',
                              data: _data.querySommaOrdini ? _data.querySommaOrdini.map(x => x.conteggio) : [],
                              backgroundColor: colors,
                            },
                          ],
                        }}
                        options={
                          {
                            maintainAspectRatio: false,
                            indexAxis: 'x' as const,
                            elements: {
                              bar: {
                                borderWidth: 2,
                              },
                            },
                            responsive: true,
                            plugins: {
                              legend: {
                                position: 'top' as const,

                              },
                            },
                          }
                        } />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Form>

      )}
    </Formik>
  );
}